import script from "./AccountComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountComponent.vue?vue&type=script&setup=true&lang=js"

import "./AccountComponent.vue?vue&type=style&index=0&id=64e5273a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e5273a"]])

export default __exports__